import { render, staticRenderFns } from "./SplitRecordManage.vue?vue&type=template&id=d0c41732&scoped=true"
import script from "./SplitRecordManage.vue?vue&type=script&lang=js"
export * from "./SplitRecordManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRecordManage.vue?vue&type=style&index=0&id=d0c41732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c41732",
  null
  
)

export default component.exports